document.addEventListener('DOMContentLoaded', () => {
  // --- Configuration ---
  const netlifyFunctionUrl = 'https://orvizoho.netlify.app/.netlify/functions/hometellus-form'; // Assuming this endpoint
  let formInitialized = false;
  let tellUsClickListenerAdded = false;
  let initializedForms = new Set(); // Track which forms have been initialized
  // --- End Configuration ---

  const waitForElement = (selector, timeout = 10000) => {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  };

  // Setup "Tell Us" link click handler
  const setupTellUsLinks = () => {
    const tellUsSelectors = [
      'a.tellus-trigger', // Example selector, adjust as needed
      'button.tellus-trigger',
      '[data-form-id="hometellus"]', // Example data attribute
      'a.get-touch', // Added specific selector for "Get In Touch"
      // Add more specific selectors for "Tell Us About Your Projects" buttons/links
      'a[href*="tell-us"]',
      'a[onclick*="tellUs"]',
      'button[onclick*="tellUs"]'
    ];

    let foundLinks = [];
    tellUsSelectors.forEach(selector => {
      try {
        const links = document.querySelectorAll(selector);
        links.forEach(link => {
          if (!foundLinks.includes(link)) {
            foundLinks.push(link);
          }
        });
      } catch (e) {
        // Invalid selector, continue
      }
    });
    
    // Also check by text content more broadly if needed
    const allRelevantElements = document.querySelectorAll('a, button');
    allRelevantElements.forEach(link => {
      const text = link.textContent.toLowerCase().trim();
      if ((text.includes('tell us') || text.includes('project')) && !foundLinks.includes(link)) {
        foundLinks.push(link);
      }
    });

    foundLinks.forEach((link) => {
      link.removeEventListener('click', tellUsClickHandler);
      link.addEventListener('click', tellUsClickHandler);
    });

    if (foundLinks.length > 0) {
      tellUsClickListenerAdded = true;
    }
  };

  const tellUsClickHandler = (e) => {
    formInitialized = false; // Reset for re-initialization if popup
    // Try to initialize quickly, then with increasing delays
    setTimeout(() => initTellUsFormInPopup(), 300); // Short delay for quick popups
    setTimeout(() => { if (!formInitialized) initTellUsFormInPopup(); }, 1000);
    setTimeout(() => { if (!formInitialized) initTellUsFormInPopup(); }, 2500);
  };

  const initTellUsFormInPopup = async () => {
    // Simple direct approach
    
    try {
      // More specific selectors for project/hometellus forms
      const formSelectors = [
        'form#TellUsForm', // Explicit ID if set
        'form#hometellus-form', // Explicit ID if set
        'form[data-orvi-handled="hometellus-script"]', // Already handled by us
        // Look for forms that contain project-related fields
        'form:has(input[name="contact[Company]"])', // Forms with company field (common in project forms)
        'form:has(textarea[name="contact[Message]"])', // Forms with message field
        // Fallback selectors for popups/modals, but we'll validate content
        '.popup form',
        '.modal form',
        'form[action*="/contact#"]' // General contact forms - will validate content
      ];

      let tellUsForm = null;
      for (const selector of formSelectors) {
        try {
          const candidateForm = await waitForElement(selector, 3000);
          if (candidateForm) {
            // Validate this is actually a project/hometellus form
            const formText = candidateForm.textContent.toLowerCase();
            const hasCompanyField = candidateForm.querySelector('input[name="contact[Company]"]');
            const hasMessageField = candidateForm.querySelector('textarea[name="contact[Message]"]');
            const isProjectForm = formText.includes('tell us about') || 
                                formText.includes('project') || 
                                formText.includes('hometellus') ||
                                (hasCompanyField && hasMessageField);
            
            if (isProjectForm) {
              tellUsForm = candidateForm;
              console.log('Hometellus script found valid project form:', {
                selector: selector,
                formId: candidateForm.id,
                hasCompany: !!hasCompanyField,
                hasMessage: !!hasMessageField,
                textIncludes: {
                  tellUsAbout: formText.includes('tell us about'),
                  project: formText.includes('project'),
                  hometellus: formText.includes('hometellus')
                }
              });
              break;
            } else {
              console.log('Hometellus script found form but not a project form, continuing search');
            }
          }
        } catch (e) { /* Continue */ }
      }

      if (!tellUsForm) {
        console.log('Hometellus script: No valid project forms found');
        return;
      }

      // Inject City field if missing for Hometellus form
      const emailInput = tellUsForm.querySelector('input[name="contact[email]"]');
      const cityInputExists = tellUsForm.querySelector('input[name="contact[city]"], input[name="contact[City]"]');
      
      if (emailInput && !cityInputExists) {
        console.log('Hometellus script: Injecting City field');
        const cityWrapper = document.createElement('div');
        // Match styling
        const parentClass = emailInput.parentElement.className;
        const inputClass = emailInput.className;
        
        cityWrapper.className = parentClass || 'form-group';
        cityWrapper.innerHTML = `
          <input type="text" name="contact[City]" id="ContactFormCity-Hometellus" class="${inputClass}" placeholder="City" required>
        `;
        
        // Insert after Phone if possible, otherwise after Email
        const phoneInput = tellUsForm.querySelector('input[name="contact[phone]"]');
        if (phoneInput) {
            const phoneContainer = phoneInput.closest('.form-group, .field, div') || phoneInput;
            if (phoneContainer.parentElement === tellUsForm || phoneContainer.parentElement.parentElement === tellUsForm) {
                 phoneContainer.after(cityWrapper);
            } else {
                 phoneInput.after(cityWrapper);
            }
        } else {
             const emailContainer = emailInput.closest('.form-group, .field, div') || emailInput;
             emailContainer.after(cityWrapper);
        }
      }

      const formId = tellUsForm.id || tellUsForm.name || tellUsForm.action || 'hometellus-form-' + Date.now();
      
      // Check if this form is already handled
      if (tellUsForm.hasAttribute('data-orvi-handled') || 
          tellUsForm.hasAttribute('data-contact-us-handled') ||
          window.OrviFormManager?.isFormHandled(tellUsForm)) {
        console.log('Hometellus script: Form already handled, skipping');
        return;
      }

      const fieldMappings = findTellUsFormFields(tellUsForm);
      const missingFields = [];
      if (!fieldMappings.firstName) missingFields.push('firstName');
      if (!fieldMappings.lastName) missingFields.push('lastName');
      if (!fieldMappings.email) missingFields.push('email');
      if (!fieldMappings.phone) missingFields.push('phone');
      if (!fieldMappings.company) missingFields.push('company');
      if (!fieldMappings.description) missingFields.push('description');

      if (missingFields.length > 0) {
        console.error('Hometellus form missing required fields:', missingFields);
        initializedForms.add(formId);
        return;
      }
      
      const boundHandler = (e) => handleTellUsFormSubmit(e, fieldMappings);
      
      // Remove any existing listeners to prevent duplicates
      if (tellUsForm._orviTellUsHandler) {
        tellUsForm.removeEventListener('submit', tellUsForm._orviTellUsHandler);
      }
      
      // Store handler reference and add event listener
      tellUsForm._orviTellUsHandler = boundHandler;
      tellUsForm.addEventListener('submit', boundHandler);
      
      // Mark form as handled to prevent conflicts
      tellUsForm.setAttribute('data-orvi-handled', 'hometellus-script');
      initializedForms.add(formId);
      formInitialized = true;
      
      console.log('Hometellus script: Successfully initialized project form', {
        formId: formId,
        action: tellUsForm.action,
        hasAllFields: missingFields.length === 0
      });

    } catch (error) {
      // Failed to initialize Tell Us form
    }
  };

  const findTellUsFormFields = (form) => {
    const mappings = {};
    const createSelectors = (shopifyName, _genericBaseName) => { // _genericBaseName is not used for now
        const selectors = [
            `input[name="contact[${shopifyName}]"]`,
            `textarea[name="contact[${shopifyName}]"]`
        ];
        // Fallback selectors if the direct ones fail, can be expanded later
        // selectors.push(`input[name*="${shopifyName.toLowerCase()}"]`, `textarea[name*="${shopifyName.toLowerCase()}"]`);
        // selectors.push(`input[placeholder*="${_genericBaseName}"i]`, `textarea[placeholder*="${_genericBaseName}"i]`);
        return selectors;
    };

    mappings.firstName = findFieldBySelectors(form, createSelectors('first_name', 'First Name'), 'firstName');
    mappings.lastName = findFieldBySelectors(form, createSelectors('last_name', 'Last Name'), 'lastName');
    mappings.email = findFieldBySelectors(form, createSelectors('email', 'Email'), 'email');
    mappings.phone = findFieldBySelectors(form, createSelectors('phone', 'Phone'), 'phone');
    mappings.city = findFieldBySelectors(form, createSelectors('City', 'City'), 'city') || findFieldBySelectors(form, createSelectors('city', 'City'), 'city');
    mappings.company = findFieldBySelectors(form, createSelectors('Company', 'Company'), 'company');
    mappings.description = findFieldBySelectors(form, createSelectors('Message', 'Message'), 'description (Message)');
    
    return mappings;
  };

  const findFieldBySelectors = (form, selectors, fieldNameForLog) => {
    for (const selector of selectors) {
      const field = form.querySelector(selector);
      if (field) {
        return field;
      }
    }
    return null;
  };

  const init = async () => {
    setupTellUsLinks();
    initTellUsFormInPopup(); // For static forms
  };

  const handleTellUsFormSubmit = async (event, fieldMappings) => {
    const form = event.target;
    // Handle form submission
    event.preventDefault();
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalButtonText = submitButton ? (submitButton.tagName === 'INPUT' ? submitButton.value : submitButton.innerHTML) : '';

    // Validate essential field mappings
    if (!fieldMappings.firstName || !fieldMappings.lastName || !fieldMappings.email || !fieldMappings.phone || !fieldMappings.company || !fieldMappings.description) {
        // Form configuration error - missing essential fields
        console.warn('Hometellus form missing essential field mappings (excluding city for now)');
        if (!fieldMappings.city) console.warn('Hometellus form missing city field mapping');
        return;
    }
    
    let formData;
    try {
      formData = {
        First_Name: (fieldMappings.firstName?.value || '').trim(),
        Last_Name: (fieldMappings.lastName?.value || '').trim(),
        Email: (fieldMappings.email?.value || '').trim(),
        Phone: (fieldMappings.phone?.value || '').trim(),
        City: (fieldMappings.city?.value || '').trim(),
        Company: (fieldMappings.company?.value || '').trim(),
        Description: (fieldMappings.description?.value || '').trim(),
        Lead_Source: "Schedule a call",
        Source_by_Group: "Schedule a call"
      };
      
      console.log('Hometellus form submitting with data:', {
        Lead_Source: formData.Lead_Source,
        Source_by_Group: formData.Source_by_Group,
        formHandler: 'hometellus-script'
      });
    } catch (error) {
      // Error reading form data
      return;
    }

    const missingRequiredFields = [];
    if (!formData.First_Name) missingRequiredFields.push('First Name');
    if (!formData.Last_Name) missingRequiredFields.push('Last Name'); // Assuming last name is also required if first name is
    if (!formData.Email) missingRequiredFields.push('Email');
    if (!formData.Phone) missingRequiredFields.push('Phone');
    if (!formData.City) missingRequiredFields.push('City');
    if (!formData.Company) missingRequiredFields.push('Company');
    if (!formData.Description) missingRequiredFields.push('Message');


    if (missingRequiredFields.length > 0) {
      // Missing required fields
      console.warn('Missing required fields:', missingRequiredFields);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.Email)) {
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      if (submitButton.tagName === 'INPUT') submitButton.value = 'Sending...';
      else submitButton.innerHTML = 'Sending...';
    }

    try {
      const response = await fetch(netlifyFunctionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ data: [formData] }), // Match Zoho structure
      });

      let result;
      try {
        result = await response.json();
      } catch (parseError) {
        throw new Error('Invalid response from server');
      }

      if (response.ok && result.success) {
        if (submitButton) {
          if (submitButton.tagName === 'INPUT') submitButton.value = 'Sent!';
          else submitButton.innerHTML = 'Sent!';
        }
        form.reset();
        setTimeout(() => {
          if (submitButton) {
            if (submitButton.tagName === 'INPUT') submitButton.value = originalButtonText;
            else submitButton.innerHTML = originalButtonText;
            submitButton.disabled = false;
          }
        }, 3000);
      } else {
        if (submitButton) {
          submitButton.disabled = false;
          if (submitButton.tagName === 'INPUT') submitButton.value = originalButtonText;
          else submitButton.innerHTML = originalButtonText;
       }
     }
   } catch (error) {
     if (submitButton) {
       submitButton.disabled = false;
       if (submitButton.tagName === 'INPUT') submitButton.value = originalButtonText;
       else submitButton.innerHTML = originalButtonText;
     }
     // TellUs Form Submission Error
   }
  };
  
  init(); // Initialize on DOMContentLoaded

  setTimeout(() => { // Fallback initialization
    if (!formInitialized) init();
  }, 2000);

  const observer = new MutationObserver((mutationsList) => {
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check for tell us form appearing dynamically
        const hasTellUsForm = document.querySelector('form#TellUsForm, form#hometellus-form, form[name="hometellus"]'); // Adjust selectors
        if (hasTellUsForm) {
          setTimeout(() => initTellUsFormInPopup(), 100);
        }
        setupTellUsLinks(); // Re-check for new links
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  ['load', 'shopify:section:load'].forEach(eventName => {
    document.addEventListener(eventName, () => setTimeout(() => initTellUsFormInPopup(), 500));
  });

  ['show.bs.modal', 'shown.bs.modal', 'modalopen', 'popup:open'].forEach(eventName => {
    document.addEventListener(eventName, () => setTimeout(() => initTellUsFormInPopup(), 300));
  });
});